import { RDSClient, DescribeDBSnapshotsCommand, RestoreDBInstanceFromDBSnapshotCommand, DescribeDBInstancesCommand, DeleteDBInstanceCommand, CreateDBSnapshotCommand, DeleteDBSnapshotCommand } from '@aws-sdk/client-rds';
import { getAWSConfig } from '../config/aws';

export const listSnapshots = async (snapshotType = 'automated', awsCredentials = null) => {
  const rdsClient = new RDSClient(getAWSConfig(awsCredentials));
  try {
    console.log(`Testing AWS credentials and listing ${snapshotType} RDS snapshots...`);
    
    let command;
    
    if (snapshotType === 'shared') {
      command = new DescribeDBSnapshotsCommand({
        SnapshotType: 'shared',
        MaxRecords: 100
      });
    } else {
      command = new DescribeDBSnapshotsCommand({
        SnapshotType: snapshotType, // 'automated' or 'manual'
        MaxRecords: 100
      });
    }
    
    console.log('Sending DescribeDBSnapshotsCommand with parameters:', {
      SnapshotType: snapshotType,
      MaxRecords: 100
    });
    
    const response = await rdsClient.send(command);
    
    console.log('AWS Credentials Test: SUCCESS');
    console.log(`RDS Snapshots found (${snapshotType}): ${response.DBSnapshots?.length || 0}`);
    
    if (response.DBSnapshots && response.DBSnapshots.length > 0) {
      console.log(`First few ${snapshotType} snapshots:`);
      response.DBSnapshots.slice(0, 3).forEach((snapshot, index) => {
        console.log(`${index + 1}. ${snapshot.DBSnapshotIdentifier} (${snapshot.Status}) - ${snapshot.Engine}`);
      });
    }
    
    return response.DBSnapshots || [];
  } catch (error) {
    console.error('AWS Credentials Test: FAILED');
    console.error('Error listing snapshots:', error);
    console.error('Error details:', {
      name: error.name,
      message: error.message,
      code: error.Code || error.$metadata?.httpStatusCode
    });
    throw error;
  }
};

export const restoreSnapshot = async (snapshotId, dbInstanceIdentifier, config = {}, awsCredentials = null) => {
  const rdsClient = new RDSClient(getAWSConfig(awsCredentials));
  try {
    const command = new RestoreDBInstanceFromDBSnapshotCommand({
      DBSnapshotIdentifier: snapshotId,
      DBInstanceIdentifier: dbInstanceIdentifier,
      DBInstanceClass: config.instanceClass || 'db.t3.micro',
      VpcSecurityGroupIds: config.securityGroupIds || [],
      DBSubnetGroupName: config.subnetGroupName,
      PubliclyAccessible: config.publiclyAccessible || true,
      MultiAZ: config.multiAZ || false,
      StorageType: config.storageType || 'gp2',
      CopyTagsToSnapshot: true,
      DeletionProtection: false
    });
    
    const response = await rdsClient.send(command);
    return response.DBInstance;
  } catch (error) {
    console.error('Error restoring snapshot:', error);
    throw error;
  }
};

export const listInstances = async (awsCredentials = null) => {
  const rdsClient = new RDSClient(getAWSConfig(awsCredentials));
  try {
    const command = new DescribeDBInstancesCommand({});
    const response = await rdsClient.send(command);
    return response.DBInstances || [];
  } catch (error) {
    console.error('Error listing instances:', error);
    throw error;
  }
};

export const getInstanceDetails = async (instanceId, awsCredentials = null) => {
  const rdsClient = new RDSClient(getAWSConfig(awsCredentials));
  try {
    console.log(`Getting details for instance: ${instanceId}`);
    const command = new DescribeDBInstancesCommand({
      DBInstanceIdentifier: instanceId
    });
    const response = await rdsClient.send(command);
    
    if (response.DBInstances && response.DBInstances.length > 0) {
      const instance = response.DBInstances[0];
      console.log(`Instance ${instanceId} status: ${instance.DBInstanceStatus}`);
      console.log(`Instance ${instanceId} endpoint: ${instance.Endpoint?.Address || 'Not available'}`);
      return instance;
    }
    return null;
  } catch (error) {
    console.error('Error getting instance details:', error);
    throw error;
  }
};

export const deleteInstance = async (dbInstanceIdentifier, skipFinalSnapshot = true, awsCredentials = null) => {
  const rdsClient = new RDSClient(getAWSConfig(awsCredentials));
  try {
    const command = new DeleteDBInstanceCommand({
      DBInstanceIdentifier: dbInstanceIdentifier,
      SkipFinalSnapshot: skipFinalSnapshot,
      DeleteAutomatedBackups: true
    });
    
    const response = await rdsClient.send(command);
    return response.DBInstance;
  } catch (error) {
    console.error('Error deleting instance:', error);
    throw error;
  }
};

export const createSnapshot = async (dbInstanceIdentifier, snapshotIdentifier, awsCredentials = null) => {
  const rdsClient = new RDSClient(getAWSConfig(awsCredentials));
  try {
    console.log(`Creating snapshot ${snapshotIdentifier} for instance ${dbInstanceIdentifier}...`);
    
    const command = new CreateDBSnapshotCommand({
      DBInstanceIdentifier: dbInstanceIdentifier,
      DBSnapshotIdentifier: snapshotIdentifier
    });
    
    const response = await rdsClient.send(command);
    console.log('Snapshot creation initiated:', response.DBSnapshot.DBSnapshotIdentifier);
    return response.DBSnapshot;
  } catch (error) {
    console.error('Error creating snapshot:', error);
    throw error;
  }
};

export const deleteSnapshot = async (snapshotIdentifier, awsCredentials = null) => {
  const rdsClient = new RDSClient(getAWSConfig(awsCredentials));
  try {
    console.log(`Deleting snapshot ${snapshotIdentifier}...`);
    
    const command = new DeleteDBSnapshotCommand({
      DBSnapshotIdentifier: snapshotIdentifier
    });
    
    const response = await rdsClient.send(command);
    console.log('Snapshot deletion initiated:', response.DBSnapshot.DBSnapshotIdentifier);
    return response.DBSnapshot;
  } catch (error) {
    console.error('Error deleting snapshot:', error);
    throw error;
  }
};